/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Fleet_RemoveInputs */

const en_clients_fleet_remove = /** @type {(inputs: Clients_Fleet_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const pt_br2_clients_fleet_remove = /** @type {(inputs: Clients_Fleet_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Clients_Fleet_RemoveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_fleet_remove = /** @type {((inputs?: Clients_Fleet_RemoveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Fleet_RemoveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_fleet_remove(inputs)
	return pt_br2_clients_fleet_remove(inputs)
});